'use client'

import Script from 'next/script'

export default function BroadstreetInit() {
  return (
    <Script
      src="https://cdn.broadstreetads.com/init-2.min.js"
      strategy="beforeInteractive"
      data-cfasync="false"
      onLoad={() => {
        if (window.broadstreet) {
          window.broadstreet.watch({
            networkId: 9415,
            softRefresh: true,
            cacheLife: 0,
          })
          window.dispatchEvent(new Event('broadstreetReady'))
        }
      }}
      id="broadstreet-init"
    />
  )
}
